import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Tooltip } from '@mui/material';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import { accent } from '../utils/colorDict';
const Dropzone=({handleFileData,fileData})=> {
    const onDrop = useCallback(file => {
      handleFileData(file)
    }, [])
    const {getRootProps, getInputProps, isDragActive} = useDropzone(
      {accept:{'image/png': ['.jpg','.png']},
        onDrop})
  
    return (
      
       <div {...getRootProps()} style={{border:'dotted 1px black'}}>
        <input {...getInputProps()}/>
        {
            fileData?.length ?   
            <Tooltip title={fileData.map(f=>f.name).join(', ')}>
            <AttachFileIcon 
            fontSize={'large'}  sx={{cursor:'pointer',color:accent}}
            /> 
            </Tooltip>
            :
          isDragActive ?
          <ArrowDropDownCircleIcon 
          fontSize={'large'} sx={{cursor:'pointer'}}
          /> :
            <Tooltip title={'drag and drop or click to upload file'}>
            <FileUploadIcon 
            fontSize={'large'} sx={{cursor:'pointer'}}
            />
            </Tooltip>
        }
    </div>
    )
  }

export default Dropzone